import type { Story } from '@tadpoles/common'

export function requireStoryTitle(story: Readonly<Story>): string {
    if (story.title === undefined || story.title.length === 0) {
        throw new Error(`Library Story ${story.id} does not have a usable title.`)
    }

    return story.title
}
